import { getAttributeValue, setAttributeValue, clearAttributeValue } from './utils';

const user = {
    state: {
        un: '',     // 名称
        tk: '',     // token
        tkt: '',    // token time
        rl: '',     // rl
    },
    getters: {
        // 获取UN
        getUn(state) {
            return getAttributeValue(state, "un");
        },
        // 获取TK
        getTk(state) {
            return getAttributeValue(state, "tk");
        },
        // 获取TKT
        getTkt(state) {
            return getAttributeValue(state, "tkt");
        },
        // 获取RL
        getRl(state) {
            return getAttributeValue(state, "rl");
        },
        getAdminRole(state) {
            return JSON.parse(getAttributeValue(state, "rl")).find(item => item === 'R_000001');
        }

    },
    mutations: {
        // 设置UN
        SET_UN: (state, un) => {
            setAttributeValue(state, "un", un);
        },
        // 设置TK
        SET_TK: (state, tk) => {
            setAttributeValue(state, "tk", tk);
        },
        // 设置TKT
        SET_TKT: (state, tkt) => {
            setAttributeValue(state, "tkt", tkt);
        },
        // 设置RL
        SET_RL: (state, rl) => {
            setAttributeValue(state, "rl", rl);
        },
        // 清除UN
        CLEAR_UN: (state) => {
            state.un = "";
            // 同步清除session
            clearAttributeValue("un");
        },
        // 清除TK
        CLEAR_TK: (state) => {
            state.tk = "";
            // 同步清除session
            clearAttributeValue("tk");
        },
        // 清除TKT
        CLEAR_TKT: (state) => {
            state.tkt = "";
            // 同步清除session
            clearAttributeValue("tkt");
        },
        // 清除RL
        CLEAR_RL: (state) => {
            state.rl = "";
            // 同步清除session
            clearAttributeValue("rl");
        }
    },
    actions: {
        // 设置UN
        setUn({ commit }, un) {
            commit('SET_UN', un);
        },
        // 设置TK
        setTk({ commit }, tk) {
            commit('SET_TK', tk);
        },
        // 设置TKT
        setTkt({ commit }, tkt) {
            commit('SET_TKT', tkt);
        },
        // 设置RL
        setRl({ commit }, rl) {
            commit('SET_RL', rl);
        },
        // 清除UN
        clearUn: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_UN');
        },
        // 清除TK
        clearTk: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_TK');
        },
        // 清除TKT
        clearTkt: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_TKT');
        },
        // 清除RL
        clearRl: ({ commit }) => {
            // 同步清除session
            commit('CLEAR_RL');
        }
    }
}

export default user;


// WEBPACK FOOTER //
// ./src/store/modules/user.js